import { render, staticRenderFns } from "./Buynowwidget.vue?vue&type=template&id=209aa9ef"
import script from "./Buynowwidget.vue?vue&type=script&lang=js"
export * from "./Buynowwidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports